import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { useApplicationContext } from '../../../core/contexts/ApplicationContext.tsx';
import { GET_TEAMS } from '../../../teams/queries.ts';

const useTeamOptions = () => {
    const { t } = useTranslation('teams');
    const { user: viewer } = useApplicationContext();

    const { data: teamsData } = useQuery(GET_TEAMS, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
    });

    return teamsData?.teams.map((team) => ({
        value: team.id,
        label: !team.isDefault ? team.name : viewer?.customer?.name || t('overview.defaultTeam'),
    }));
};

export default useTeamOptions;
